// extracted by mini-css-extract-plugin
export default {"row":"cdubyl3FvyukBE8FulTD","row-text":"vH7CaFLHwtRh5h2i84eb","rowText":"vH7CaFLHwtRh5h2i84eb","option":"B3NdvSOqqYc8k3gXO4S5"};